<template>
    <section class="d-flex justify-space-between" v-if="!loading">
        <v-card class="pa-5 mr-5" max-width="925" width="100%">
            <div class="d-flex mb-5">
                <div>
                    <v-img :src="`${API_URL}/storage/${post.picture}`" max-width="278" max-height="180"></v-img>
                </div>

                <div class="ml-2 mr-4 title-description">
                    <v-card-title class="pt-0 pb-2">{{post.title}}</v-card-title>

                    <v-card-text class="black--text pr-0" v-html="post.description"></v-card-text>
                </div>
            </div>

            <p>
                <strong>{{$t("blog.created_at")}}:</strong>
                {{post.created_at}}
            </p>

            <p v-if="post.external_link">
                <strong class="mr-1">{{$t("blog.external_link")}}:</strong>
                <a :href="post.external_link" target="_blank" class="green--text">{{post.external_link}}</a>
            </p>

            <p v-if="$i18n.locale === 'am'">
                {{post.teacher.full_name}}<strong>-ի կողմից</strong>
            </p>
            <p v-else>
                <strong>By:</strong>
                {{post.teacher.full_name}}
            </p>

            <div class="d-flex align-center mb-4" v-if="hasRole('teacher')">
                <svg v-svg="'icon-views'" size="20 12" class="mr-1"></svg>
                <span>{{post.views}}</span>
            </div>

            <iframe width="100%" height="496" :src="`https://www.youtube.com/embed/${yt_id}?autoplay=1&mute=1`" allowfullscreen v-if="post.video_link"></iframe>
        </v-card>

        <div class="d-flex flex-column">
            <v-card v-for="(item, index) in POSTS" :key="index" class="pa-3 pr-5 mb-7 d-flex align-center" height="90" :to="{name : 'Post', query: {post_id : item.id}}" @click="[getPost(), addView()]">
                <div>
                    <v-img :src="`${API_URL}/storage/${item.picture}`" max-width="106" max-height="68.65"></v-img>
                </div>

                <div class="d-flex flex-column justify-space-between ml-3">
                    <div>
                        <strong class="latest-post-title">{{item.title}}</strong>

                        <p class="by mb-0" v-if="$i18n.locale === 'am'">
                            {{item.teacher.full_name}}<strong>-ի կողմից</strong>
                        </p>
                        <p class="by mb-0" v-else>
                            <strong>By:</strong>
                            {{item.teacher.full_name}}
                        </p>
                    </div>

                    <div class="d-flex align-center" v-if="hasRole('teacher')">
                        <svg v-svg="'icon-views'" size="20 12" class="mr-1"></svg>
                        <span>{{item.views}}</span>
                    </div>
                </div>
            </v-card>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        data(){
            return {
                loading: true,
                post: {},
                yt_id: null,
            }
        },

        computed: mapGetters(['POSTS']),

        methods: {
            getPost(){
                this.$api('posts').show(this.$route.query.post_id).then(res => {
                    this.post = res.data.post;
                    let url = res.data.post.video_link.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
                    this.yt_id = undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
                    this.loading = false;
                })
            },
            addView(){
                this.$api('posts').addView(this.$route.query.post_id);
            }
        },

        mounted() {
            this.getPost();
            this.addView();
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/Blog/singlePage";
</style>